interface Props {
  className?: string;
}

export default function WalletIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 3C16.5304 3 17.0391 3.21071 17.4142 3.58579C17.7893 3.96086 18 4.46957 18 5V7.005L19.6992 7.00075C19.8652 7.00034 20 7.13417 20 7.30015C20 7.79263 20 8.74329 20 9V13C20 13.2568 20 14.2083 20 14.7006C20 14.8663 19.8657 15 19.7 15H18V17C18 17.5304 17.7893 18.0391 17.4142 18.4142C17.0391 18.7893 16.5304 19 16 19H2C1.46957 19 0.960859 18.7893 0.585786 18.4142C0.210714 18.0391 0 17.5304 0 17V5C0 4.46957 0.210714 3.96086 0.585786 3.58579C0.960859 3.21071 1.46957 3 2 3H16ZM16 5H2V17H16V15H11.1442C11.0531 15 10.9669 14.9586 10.9099 14.8874L8.00104 11.2498C7.88424 11.1038 7.88424 10.8962 8.00104 10.7502L10.9099 7.11264C10.9669 7.04145 11.0531 7 11.1442 7H16V5ZM18.5 8.7C18.5 8.58954 18.4105 8.5 18.3 8.5H11.6059C11.5397 8.5 11.4777 8.5328 11.4405 8.5876L9.95403 10.7752C9.86182 10.9109 9.86182 11.0891 9.95403 11.2248L11.4405 13.4124C11.4777 13.4672 11.5397 13.5 11.6059 13.5H18.3C18.4105 13.5 18.5 13.4105 18.5 13.3V8.7ZM13 10C13.2652 10 13.5196 10.1054 13.7071 10.2929C13.8946 10.4804 14 10.7348 14 11C14 11.2652 13.8946 11.5196 13.7071 11.7071C13.5196 11.8946 13.2652 12 13 12C12.7348 12 12.4804 11.8946 12.2929 11.7071C12.1054 11.5196 12 11.2652 12 11C12 10.7348 12.1054 10.4804 12.2929 10.2929C12.4804 10.1054 12.7348 10 13 10Z"
        fill="currentColor"
      />
      <path d="M2 3.63232L13 1" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M13.5632 3.03783L13.8066 3.47459L14.6802 2.9878L14.4368 2.55104L13.5632 3.03783ZM13.4368 0.756604C13.3023 0.515388 12.9978 0.428817 12.7566 0.563241C12.5154 0.697665 12.4288 1.00218 12.5632 1.2434L13.4368 0.756604ZM14.4368 2.55104L13.4368 0.756604L12.5632 1.2434L13.5632 3.03783L14.4368 2.55104Z"
        fill="currentColor"
      />
    </svg>
  );
}
